import type { CountryISO } from '@/shared/types'

type GeoState = {
  countryCode: CountryISO | undefined
}

export const state = reactive<GeoState>({
  countryCode: undefined,
})
